import React from "react";
import "../assets/style/misc/App.scss";
import { NavLink  } from "react-router-dom";

const InfraCard = ({ data }) => {
    return (
        <div className="my-card col-lg-2 col-md-4 col-12">
            { data.image ? 
                <img src={data.image} className="image" alt="infrastructure-item"/> :
                <div className="teriary centered-column-container text-secondary">A venir</div>
            }
            
            <div className="card-body centered-column-container">
                <h5 className="card-title">{data.name}</h5>
                <p className="card-text">
                    {data.text}
                </p>
            </div>
        </div>
    )
}


const manege = {
    image: null,
    name: "MANÈGE DE 20 x 57 m",
    text: "Le manège en sable de Fontainebleau fibré avec un système d’arrosage par subirrigation permettant un arrosage optimal en combinaison avec un hersage régulier.",
};

const carriere = {
    image: "pictures/infrastructures/carriere.jpg",
    name: "CARRIÈRE DE 25 x 50 m",
    text: "La carrière en sable régulièrement entretenue et hersée.",
};

const rond = {
    image: "pictures/infrastructures/rond_de_longe.jpg",
    name: "ROND DE LONGE DE 18 m",
    text: "Le rond de longe en sable régulièrement entretenu et hersé.",
};

const exterieur = {
    image: "pictures/infrastructures/exterieur.jpg",
    name: "EXTÉRIEUR",
    text: "Située au pied des Vosges, l’écurie offre un accès direct à de nombreuses balades et une belle diversité de paysages (champs, forêts, montagne). De quoi ravir les amateurs d'extérieur !",
};

const douche = {
    image: null,
    name: "DOUCHE & PANSAGE",
    text: "Pour les soins et la préparation des chevaux, des aires de pansage sont présentes ainsi qu’une douche.",
};

const sellerie = {
    image: null,
    name: "SELLERIE",
    text: "Chaque propriétaire dispose d’un casier individuel dans la sellerie.",
};

const club = {
    image: null,
    name: "CLUB HOUSE",
    text: "Pour pouvoir se retrouver entre cavaliers, un Club House équipé (réfrigérateur, micro-onde, etc.).",
};


const Infrastructure = () => {
    return(
        <div className="page-container">
            <div className="page-header">
                <h1 className="page-title">Nos Infrastructures</h1>
                <p className="page-subtitle">Pour votre bien-être et celui de votre cheval, le Havre de Priya met à disposition de ses pensionnaires les infrastructures suivantes :</p>
            </div>
            <div className="section centered-column-container">
                <h2 className="section-title"> Pour le travail de votre cheval </h2>
                <div className="card-container">
                    <InfraCard data={manege}></InfraCard>
                    <InfraCard data={carriere}></InfraCard>
                    <InfraCard data={rond}></InfraCard>
                    <InfraCard data={exterieur}></InfraCard>
                </div>
            </div>
            <div className="section centered-column-container primary">
                <h2 className="section-title"> Pour le quotidien </h2>
                <div className="card-container">
                    <InfraCard data={douche}></InfraCard>
                    <InfraCard data={sellerie}></InfraCard>
                    <InfraCard data={club}></InfraCard>
                </div>
            </div>
            <div className="section centered-row-container to-column">
                <img src="pictures/contactBack.jpg" className="contact-footer-image" alt="footer-image"/>
                <div className="d-flex flex-column justify-content-center align-items-md-start align-items-center spacing">
                    <h2 className="section-title">Des questions ?</h2>
                    <p className="section-text">N'hésitez pas à nous contacter par téléphone, via nos réseaux ou encore par mail afin d'échanger sur vos besoins</p>
                    <button className="action-btn large"><NavLink to="/contact">Contactez-nous</NavLink></button>
                </div>
            </div>
        </div>
    );
}

export default Infrastructure;